import { DocumentV2 } from '@eigtech/documents-types'

export const getDocumentTitle = (document: DocumentV2): string =>
  (document.title ?? document.notes ?? document.filename ?? '').replace(
    'Document Imported to XA from Cinnamon.',
    'Document Imported to XA from Cinnamon - '
  )

export const getDocumentDescription = (document: DocumentV2): string => document.description ?? ''
